/**
 * URL of the interview app. Used for links to CV edit (edit lives in interview app).
 * Set via VITE_INTERVIEW_URL (e.g. http://localhost:5173 in dev).
 */
export const getInterviewUrl = (): string =>
  import.meta.env.VITE_INTERVIEW_URL || 'http://localhost:5173';
